// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3AuRN","content":"GlobalSearch_content__2ZaWA"};